
import { useState } from 'react';
import { TestVersion } from '@/types/personality';

import BigFiveTestInterface from './BigFiveTestInterface';
import BigFiveTestResults from './BigFiveTestResults';

interface BigFiveTestProps {
  version: TestVersion;
}

export default function BigFiveTest({ version }: BigFiveTestProps) {
  const [showResults, setShowResults] = useState(false);
  const [testResults, setTestResults] = useState<any>(null);
  const [savedResultId, setSavedResultId] = useState<string | null>(null);
  const [showAnalysisModal, setShowAnalysisModal] = useState(false);
  const [selectedAnalysis, setSelectedAnalysis] = useState<any>(null);
  const [selectedInsight, setSelectedInsight] = useState<any>(null);

  const handleTestComplete = (results: any, resultId: string | null) => {
    setTestResults(results);
    setSavedResultId(resultId);
    setShowResults(true);
  };

  const handleAnalysisComplete = (analysis: any, insight: any) => {
    setSelectedAnalysis(analysis);
    setSelectedInsight(insight);
    setShowAnalysisModal(true);
  };

  const handleResetTest = () => {
    setShowResults(false);
    setTestResults(null);
    setSavedResultId(null);
    setShowAnalysisModal(false);
    setSelectedAnalysis(null);
    setSelectedInsight(null);
  };
  
  return (
    <div className="container mx-auto p-4 space-y-8">
      {showResults ? (
        <BigFiveTestResults
          testResults={testResults}
          savedResultId={savedResultId}
          showAnalysisModal={showAnalysisModal}
          selectedAnalysis={selectedAnalysis}
          selectedInsight={selectedInsight}
          onResetTest={handleResetTest}
          onAnalysisComplete={handleAnalysisComplete}
          onCloseAnalysisModal={() => setShowAnalysisModal(false)}
        />
      ) : (
        <BigFiveTestInterface
          version={version}
          onTestComplete={handleTestComplete}
        />
      )}
    </div>
  );
}
